import React, { useState } from 'react';

// material
import { Alert, Box, Card, Container, Snackbar, Tab } from '@mui/material';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// components
import { HeaderHeight } from '../Constants';
import Header from '../components/navbar/Header';
import useFeatures from '../components/customContextProviders/FeatureContext';
import Profile from '../components/_dashboard/smartlock/Profile';
import ControlCenter from '../components/_dashboard/smartlock/ControlCenter';
import Page from '../components/Page';

// ----------------------------------------------------------------------

export default function SmartlockBoxControlCenter() {
  const feature = useFeatures();

  const [alertMetas, setAlertMetas] = useState({
    snackBarOpened: false,
    msg: '',
    variant: 'filled',
    severity: ''
  });
  const [selectedDeviceTab, setSelectedDeviceTab] = useState(
    feature?.controlCenter?.controlCenterSetting ? '1' : '2'
  );
  const [open, setOpen] = useState(false);

  const handleDeviceTabChange = (event, newValue) => {
    setSelectedDeviceTab(newValue);
  };

  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setAlertMetas({ ...alertMetas, snackBarOpened: false });
  // };

  return (
    <Page title="Control Centre">
      <Header
        onOpenSidebar={() => setOpen(true)}
        // handleSearch={handleTripSearch}
        // handleSubmit={searchTrip}
        name={selectedDeviceTab === '1' ? '  Control Centre' : 'Profile'}
        showSearch={false}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={alertMetas?.snackBarOpened}
        // onClose={handleSnackBarClose}
        autoHideDuration={6000}
      >
        <Alert
          // onClose={handleSnackBarClose}
          variant={alertMetas?.variant}
          severity={alertMetas?.severity}
        >
          {alertMetas?.msg}
        </Alert>
      </Snackbar>

      <Container maxWidth="false" disableGutters sx={{ padding: 0 }}>
        <Card
          sx={{
            pt: 2,
            boxShadow: '0px 10px 19px 1px #EAEAFF',
            bgcolor: '#FFFFFF',
            height: `calc(100vh - ${HeaderHeight + 40}px)`,
            overflow: 'auto'
          }}
        >
          <Box sx={{ width: '100%' }}>
            <TabContext value={selectedDeviceTab}>
              <Box>
                <TabList
                  sx={{
                    '& .Mui-selected': {
                      fontWeight: 700,
                      opacity: '100% !important'
                    },
                    '& .MuiTab-root': {
                      fontSize: { xs: '14px', sm: '16px' },
                      opacity: '40%'
                    },
                    '& .MuiTabs-indicator': {
                      height: '5px'
                    }
                  }}
                  onChange={handleDeviceTabChange}
                  value={selectedDeviceTab}
                  aria-label="Control Center"
                >
                  {feature?.controlCenter?.controlCenterSetting && (
                    <Tab label="Devices" value="1" />
                  )}
                  <Tab label="Profile" value="2" />
                </TabList>
              </Box>
              {feature?.controlCenter?.controlCenterSetting && (
                <TabPanel value="1" sx={{ p: 0, pt: 3 }}>
                  <ControlCenter alertMetas={alertMetas} setAlertMetas={setAlertMetas} />
                </TabPanel>
              )}
              <TabPanel value="2" sx={{ p: 0, pt: 3 }}>
                <Profile alertMetas={alertMetas} setAlertMetas={setAlertMetas} />
              </TabPanel>
            </TabContext>
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
